export default function EveningRoutine() {
  return (
    <section className="w-full bg-background-50 py-12 md:py-20">
      <div className="w-full px-4 sm:px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row gap-10 md:gap-16 items-center">
            <div className="w-full md:w-1/2">
              <div className="relative overflow-hidden rounded-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20and%20cosy%20corner%20of%20a%20quiet%20home%20in%20the%20evening%2C%20a%20soft%20chunky%20knit%20blanket%20draped%20over%20an%20armchair%2C%20an%20open%20hardcover%20book%20resting%20on%20the%20blanket%2C%20a%20ceramic%20mug%20of%20herbal%20tea%20on%20a%20wooden%20side%20table%20beside%20a%20lit%20soy%20candle%20casting%20a%20warm%20gentle%20glow%2C%20a%20leather%20bound%20journal%20nearby%2C%20soft%20amber%20and%20cream%20tones%2C%20restorative%20calm%20atmosphere%2C%20no%20alcohol%20visible%2C%20premium%20editorial%20photography%2C%20intimate%20and%20nurturing%20mood&width=1200&height=900&seq=evening-routine-2026&orientation=landscape"
                  alt="A warm cosy corner at home with a knit blanket, open book, herbal tea, and a lit candle, calm restorative evening atmosphere"
                  className="w-full h-auto object-cover"
                />
              </div>

              <div className="mt-6 bg-background-100 rounded-lg p-6 border border-background-200/50"
              >
                <div className="grid grid-cols-3 gap-4">
                  <div className="flex flex-col items-center text-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                      <i className="ri-message-3-line text-lg" />
                    </div>
                    <div>
                      <p className="font-body text-sm font-medium text-foreground-800">
                        Text check-ins
                      </p>
                      <p className="font-body text-xs text-foreground-500 mt-0.5">
                        Steady support when you need it
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col items-center text-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                      <i className="ri-book-open-line text-lg" />
                    </div>
                    <div>
                      <p className="font-body text-sm font-medium text-foreground-800">
                        Evening guides
                      </p>
                      <p className="font-body text-xs text-foreground-500 mt-0.5">
                        Journaling and reflection tools
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col items-center text-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                      <i className="ri-heart-2-line text-lg" />
                    </div>
                    <div>
                      <p className="font-body text-sm font-medium text-foreground-800">
                        Calm rituals
                      </p>
                      <p className="font-body text-xs text-foreground-500 mt-0.5">
                        Nurturing routines that stick
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full md:w-1/2">
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light text-foreground-950 mb-6">
                Do You Breathe a Sigh of Relief&hellip; Then Reach for a Drink?
              </h2>

              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                For many people, drinking doesn&rsquo;t begin because they&rsquo;re celebrating.
              </p>

              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                It begins because they&rsquo;re exhausted.
              </p>

              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-2">
                The work is finished.
              </p>
              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-2">
                The emails have stopped.
              </p>
              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-2">
                The children are in bed.
              </p>
              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                The house is finally quiet.
              </p>

              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                And alcohol becomes the reward&hellip; the escape&hellip; or simply the way to get through another evening.
              </p>

              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                If that sounds familiar, you&rsquo;re not alone.
              </p>

              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
                Inside Serena&rsquo;s Quiet Recovery Space, you&rsquo;ll learn why evenings often become the hardest part of the day, what your drinking may really be communicating, and how to create healthier ways to unwind&mdash;privately, compassionately and at your own pace.
              </p>

              <ul className="space-y-3 mb-6">
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-500 text-sm" />
                  </div>
                  <span className="font-body text-sm text-foreground-700">Understand your evening triggers</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-500 text-sm" />
                  </div>
                  <span className="font-body text-sm text-foreground-700">Recognise hidden emotional patterns</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-500 text-sm" />
                  </div>
                  <span className="font-body text-sm text-foreground-700">Break the cycle of drinking on autopilot</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-500 text-sm" />
                  </div>
                  <span className="font-body text-sm text-foreground-700">Build calming routines that support lasting change</span>
                </li>
              </ul>

              <p className="font-body text-sm md:text-base text-foreground-600 italic">
                🌿 Because recovery isn&rsquo;t about judging yourself. It&rsquo;s about understanding yourself.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}